<template>
  <va-edit-layout :actions="['list', 'show', 'delete']">
    <amendments-form :id="id" :title="title" :item="item"></amendments-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ['id', 'title', 'item'],
}
</script>
